import * as Cookies from "es-cookie"

export const checkLogoutNonce = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const logoutNonce = searchParams.get("logoutNonce")
  const cookiesLogoutNonce = Cookies.get("logoutNonce")
  Cookies.remove("logoutNonce")
  return (
    logoutNonce &&
    cookiesLogoutNonce &&
    decodeURIComponent(cookiesLogoutNonce) === logoutNonce
  )
}
